module.exports = __webpack_public_path__ + "fonts/lato_thin.c65fe929.woff";